import React from 'react';
import './DisclaimerBanner.css';

const DisclaimerBanner = () => {
  return (
    <div className="disclaimer-banner">
      <div className="disclaimer-content">
        <h3 className="disclaimer-title">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="disclaimer-icon"
          >
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="16" x2="12" y2="12"></line>
            <line x1="12" y1="8" x2="12.01" y2="8"></line>
          </svg>
          Transparency Note
        </h3>
        <p className="disclaimer-text">
          Fantomize is a search engine, not a retailer. We do not sell products directly.
          When you click on a product, you will be redirected to the official retailer's website.
        </p>
      </div>
    </div>
  );
};

export default DisclaimerBanner;

